import {BrowserModule} from '@angular/platform-browser';
import {ErrorHandler, NgModule} from '@angular/core';
import {IonicApp, IonicModule} from 'ionic-angular';
import {StatusBar} from '@ionic-native/status-bar';
import {MyApp} from './app.component';
import {HomePage} from '../pages/home/home';
import {HttpClientModule, HttpClient} from '@angular/common/http';
import {SDKBrowserModule} from '../sdk';
import {LoginPage} from "../pages/login/login";
import {HomogenizationOrderListPage} from "../pages/homogenization-order-list/homogenization-order-list";
import {HomogenizationOrderListPageModule} from "../pages/homogenization-order-list/homogenization-order-list.module";
import {
  HomogenizationOrderInlineAddPage
} from "../pages/homogenization-order-inline-add/homogenization-order-inline-add";
import {
  HomogenizationOrderInlineAddPageModule
} from "../pages/homogenization-order-inline-add/homogenization-order-inline-add.module";
import {HomogenizationOrderOutlineAddPage} from "../pages/homogenization-order-outline-add/homogenization-order-outline-add"
import {HomogenizationOrderOutLineAddPageModule} from "../pages/homogenization-order-outline-add/homogenization-order-outline-add.module";
import {HomogenizationOrderAddPage} from "../pages/homogenization-order-add/homogenization-order-add"
import {HomogenizationOrderAddPageModule} from "../pages/homogenization-order-add/homogenization-order-add.module";
import {HomePageModule} from '../pages/home/home.module';
import {LoginPageModule} from '../pages/login/login.module';
import {AppVersion} from '@ionic-native/app-version';
import {LocationAccuracy} from '@ionic-native/location-accuracy';
import {DatePickerModule} from 'ion-datepicker';
import {ServerProvider} from '../providers/server-provider';
import {ErrorsHandler} from './errors-handler';
import {AlertComponent} from '../components/alertComponent';
import {LoadingComponent} from '../components/loadingComponent';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {FaqPageModule} from '../pages/faq/faq.module';
import {FaqPage} from '../pages/faq/faq';
import {AutoupdateProvider} from '../providers/autoupdate-provider';
import {IsDebug} from '@ionic-native/is-debug';
import {Market} from '@ionic-native/market';
import {MomentModule} from 'angular2-moment/moment.module';
import * as ionicGalleryModal from 'ionic-gallery-modal';
import {HAMMER_GESTURE_CONFIG} from '@angular/platform-browser';
import {ChartModule} from 'angular2-chartjs';
import {EnvironmentsModule} from "../../envioronment-variables/environment-variables.module";
import { StorageCacheProvider } from '../providers/storage-cache-provider';
import {CustomSelectorPageModule} from "../pages/custom-selector/custom-selector.module";
import {CustomSelectorPage} from "../pages/custom-selector/custom-selector";


export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
    declarations: [
        MyApp
    ],
    imports: [
        EnvironmentsModule,
        HttpClientModule,
        BrowserModule,
        IonicModule.forRoot(MyApp),
        SDKBrowserModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        HomePageModule,
        LoginPageModule,
        HomogenizationOrderListPageModule,
        HomogenizationOrderInlineAddPageModule,
        HomogenizationOrderOutLineAddPageModule,
        HomogenizationOrderOutLineAddPageModule,
        HomogenizationOrderAddPageModule,
        CustomSelectorPageModule,
        FaqPageModule,
        DatePickerModule,
        BrowserAnimationsModule,
        MomentModule,
        ionicGalleryModal.GalleryModalModule,
        ChartModule
    ],
    bootstrap: [IonicApp],
    entryComponents: [
        MyApp,
        HomePage,
        LoginPage,
        HomogenizationOrderListPage,
        HomogenizationOrderInlineAddPage,
        HomogenizationOrderOutlineAddPage,
        HomogenizationOrderAddPage,
        CustomSelectorPage,
        FaqPage
    ],
    providers: [
        ServerProvider,
        StatusBar,
        AppVersion,
        LocationAccuracy,
        {provide: ErrorHandler, useClass: ErrorsHandler},
        AutoupdateProvider,
        AlertComponent,
        LoadingComponent,
        StorageCacheProvider,
        IsDebug,
        Market,
        {
            provide: HAMMER_GESTURE_CONFIG,
            useClass: ionicGalleryModal.GalleryModalHammerConfig,
        }
    ]
})
export class AppModule {
}





// WEBPACK FOOTER //
// ./src/app/app.module.ts